import { atom } from "recoil"

export const notificationTokenAtom = atom({
    key: "notificationTokenAtom",
    default: null
})

export const notificationStatusAtom = atom({
    key: "notificationStatusAtom",
    default: false
})
